import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { Constant } from '../../environments/constants';
// import { Utils } from '../../utils/utils';
// import { tap } from 'rxjs/operators';
// import { of } from 'rxjs';
import { User } from './../models';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private user: User;
  constructor(private http: HttpClient) { }

  getUser() {
    return this.user;
  }
  
  setUser(ur) {
    let isSuper = this.isSuperUser(ur);
    ur.isSuperUser = isSuper;
    this.user = ur;
  }

  private isSuperUser(user){
    if(user && user.repIds && user.repIds.length>0){
      const adminRepId = user.repIds.find(id=> id.trim() === "000");
      if(adminRepId){
        return true;
      }
    }
    return false;
  }
}
